<template>
  <v-layout v-if="user" pl-2 pt-2 pr-2 pb-2 justify-center row wrap>
    <v-flex xs4 xl2 lg3>
      <v-layout column>
        <SimpleCard>
          <v-layout column>
            <v-flex xs12>
              <h3>{{user.name}}</h3>
              <p>
                <a :href="'mailto:' + user.email">{{ user.email }}</a>
              </p>
              <p>
                <a :href="'tel:' + formatNumber(user.contact_number) ">{{ user.contact_number }}</a>
              </p>
              <v-btn
                style="margin-left: 0px;"
                class="text-none"
                flat
                @click="showResetPassword = true"
              >
                <v-icon left dark>security</v-icon>Reset Password
              </v-btn>
              <v-btn
                style="margin-left: 0px;"
                class="text-none"
                flat
                @click="optOutIn"
              >
                <v-icon left dark>security</v-icon>{{user.marketing_opt_out ? 'Marketing Opt In' : 'Marketing Opt Out'}}
              </v-btn>
            </v-flex>
          </v-layout>
        </SimpleCard>
        <v-flex pt-2>
          <SimpleCard>
            <v-layout column>
              <v-flex pb-3>
                <h3>Customer Options</h3>
              </v-flex>
              <a
                target="_blank"
                :href="'/bookings?contact_number=' + user.contact_number + '&name=' + user.name"
              >
                <h4>View Bookings</h4>
              </a>
              <router-link :to="`/customer/edit/${user.id}`">
                <h4>Update Details</h4>
              </router-link>
            </v-layout>
          </SimpleCard>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex lg4 xl5 xs8 pl-2>
      <SimpleCard>
        <PaymentCards :bookingForm="{ 'user' : user }" />
      </SimpleCard>
    </v-flex>
    <v-flex xs3></v-flex>
    <v-flex xs6 pt-3>
      <SimpleCard>
      <NoMatchPanel v-if="user != null" :user="user"></NoMatchPanel>
      </SimpleCard>
    </v-flex>
    <v-flex xs3></v-flex>
     <v-flex xs6 pt-3>
      <SimpleCard>
      <UserRideTypeWaitTimePanel v-if="user != null" :reload="getUserInfo" :user="user"></UserRideTypeWaitTimePanel>
      </SimpleCard>
    </v-flex>
    <ResetPassword
      :show="showResetPassword"
      :userID="user.id"
      :userName="user.name"
      @hideResetPassword="showResetPassword = false"
    />
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">{{ snackbarMessage }}</v-snackbar>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import ResetPassword from "@/components/customer/ResetPassword.vue";
import PaymentCards from "@/components/customer/PaymentCards.vue";
import { replaceStart } from "@/components/util/PhoneNumbers.js";
import NoMatchPanel from "@/components/nomatch/NoMatchPanel.vue";
import UserRideTypeWaitTimePanel from "@/components/waiting_time/UserRideTypeWaitTimePanel.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "customer",
  components: {
    SimpleCard,
    ResetPassword,
    PaymentCards,
    NoMatchPanel,
    UserRideTypeWaitTimePanel
  },
  data: function() {
    return {
      mode: "trips",
      user: null,
      loading: true,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null,
      showResetPassword: false
    };
  },
  mounted: async function() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo: async function() {
      let self = this;
      let url = `${this.$store.state.apiUrl}/customer/${this.$route.params.id}/get`;

      axios
        .get(url)
        .then(function(response) {
          if (!response.error) {
            if (response.data.user) {
              self.user = response.data.user;
            } else {
              self.snackbarMessage = "Error fetching customer, no user data";
              self.snackbarColour = "error";
              self.snackbarShow = true;
            }
          } else {
            console.log(response.error);
            self.snackbarMessage = "Error fetching customer: " + response.error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          }
          self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          self.snackbarMessage = error;
          self.snackbarColour = "error";
          self.snackbarShow = true;
          self.loading = false;
        });
    },
    optOutIn: async function() {
      let self = this;
      let url = `${this.$store.state.apiUrl}/customer/optOutOfMarketing?user_id=${this.$route.params.id}&opt_out=${!this.user.marketing_opt_out}`;

      axios
        .post(url)
        .then(function(response) {
          if (!response.error) {
            self.user.marketing_opt_out = !self.user.marketing_opt_out
          } else {
            console.log(response.error);
            self.snackbarMessage = "Error updating customer: " + response.error;
            self.snackbarColour = "error";
            self.snackbarShow = true;
          }
          self.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          self.snackbarMessage = error;
          self.snackbarColour = "error";
          self.snackbarShow = true;
          self.loading = false;
        });
    },
    formatNumber: function(number) {
      return replaceStart(number);
    }
  }
};
</script>

<style  lang="scss">
h4 {
  padding-top: 3px;
  padding-bottom: 3px;
}
</style>